export const ADD_WIDGET = "ADD_WIDGET";
export const ADD_PACKAGE = "ADD_PACKAGE";
export const CLEAR_PRODUCT = "CLEAR_PRODUCT";
export const UPDATE_WIDGET = "UPDATE_WIDGET";

type ProductAction = typeof ADD_WIDGET | typeof ADD_PACKAGE | typeof CLEAR_PRODUCT | typeof UPDATE_WIDGET;

export interface ProductPayload {
  type: ProductAction
  data: any;
}
